import { AhaMomentImage } from '@fruitful/types';
import { type ImageSourcePropType } from 'react-native';

import DiscoverImage from '../../assets/images/discover.png';
import DiscoverBwImage from '../../assets/images/discover-bw.png';
import InvestingImage from '../../assets/images/investing.png';
import ManagementImage from '../../assets/images/management.png';
import RoadmapImage from '../../assets/images/roadmap.png';
import SecureSavingsImage from '../../assets/images/secure-savings.png';

export const AHA_MOMENT_IMAGES: Record<AhaMomentImage, ImageSourcePropType> = {
    [AhaMomentImage.Discover]: DiscoverImage,
    [AhaMomentImage.DiscoverBw]: DiscoverBwImage,
    [AhaMomentImage.Investing]: InvestingImage,
    [AhaMomentImage.Management]: ManagementImage,
    [AhaMomentImage.Roadmap]: RoadmapImage,
    [AhaMomentImage.SecureSavings]: SecureSavingsImage,
};

export const getAhaMomentImageSource = (
    image: AhaMomentImage,
): ImageSourcePropType =>
    AHA_MOMENT_IMAGES[image] ?? AHA_MOMENT_IMAGES[AhaMomentImage.DiscoverBw];
